import { Box, Fade, Modal, Typography } from '@mui/material'
import { ReactComponent as CloseIcon } from "../../../assets/icons/icon_close.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icons/icon_filter.svg";
import CircularProgress from '@mui/material/CircularProgress';
import { Table } from 'antd';
import React, { useEffect, useState } from 'react'
import ReportGraph from '../../../pages/ReportGraph';
import CubeReqMapper from "../../../utils/CubeReqMapper";
import GetUserInfo from "../../../pages/externalReports/GetUserInfo";
import ReportFilterMenu from '../dashboard/ReportFilterMenu';


function ReportHyperLink({hyperlinkModal,closeHyperlinkModal,loader,hyperlinkReportData,hyperlinkExtUrl,hyperlinkType,userInfo,extReportType, 
    chartType=null, isTable=false, reportIn = null, h = null, hasFilters = false, hasLinkedReports = false, comparisonChartType = false}) {
  //console.log(extReportType,hyperlinkExtUrl)
  const [reportQuery,setReportQuery] = useState(null)
  const [isFilters,setIsFilters] = useState(false)
  //console.log(isFilters,hyperlinkModal,reportQuery)
  const updateFilters = (report) => {
    //console.log(report)
  }
  useEffect(() => {
    //console.log(hyperlinkReportData)
  })
  useEffect(() => {
    if(hyperlinkReportData){
      setReportQuery({...hyperlinkReportData})
    } 
    setIsFilters(hasFilters)   
  },[hyperlinkReportData])
  return (
    <Modal
           aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root dashboard-report-modal"
            open={hyperlinkModal}
            onClose={closeHyperlinkModal}
            closeAfterTransition
          >
            <Fade in={hyperlinkModal}>
              <Box className="modal-paper modal-box modal-xl" id="transition-modal-title">                
                <CloseIcon  className="enlarge-close" onClick={closeHyperlinkModal} />
                <Box className="modal-header" >
                  <Typography variant="subtitle1" className="modal-header-title" >{(hyperlinkType === 'ext' &&
                       extReportType === "getUserInfoByUuid") ? 'Student Details' :  reportQuery?.reportName ? `${reportQuery?.reportName}`: ''}</Typography>
                    {
                      hasFilters && reportQuery ? (
                        <ReportFilterMenu
                          icon={<FilterIcon />}
                          report={reportQuery}
                          reportIndex={0}
                          updateReport={updateFilters}
                          selectedReports={[reportQuery]}
                        />
                      ):null
                    }
                  </Box>
                   <Box className={`modal-content ` + ((isTable || chartType === 'table') ? 'modal-contentY-full' : '')}> 
                   
                   { hyperlinkType === 'int' && reportQuery ?
                     <ReportGraph reportDetails={CubeReqMapper(reportQuery)} openToolBar={false}
                     reportIn={reportIn} h={h} hasFilters={hasFilters} hasLinkedReports={hasLinkedReports} comparisonChartType={comparisonChartType} />
                     : hyperlinkType === 'ext' &&
                       extReportType === "getUserInfoByUuid" ? 
                       <GetUserInfo userInfo={userInfo}/> : 
                       hyperlinkType === 'ext' && hyperlinkExtUrl ?
                     <>
                       <iframe style={{display: 'block', width:'100%', height:'70vh'}} src={`${hyperlinkExtUrl}`} frameborder="0"></iframe>
                     </>
                     : null
                   }
                  </Box>
              </Box>
            </Fade>
        </Modal>
  )
}

export default ReportHyperLink